module.exports = __webpack_public_path__ + "static/profile-01ddabc8a5f80084c0713eb8945d7a9c.jpg";